import { ChevronLeft, ChevronRight } from 'lucide-react'
import { NavBar, NavButton, NavLabel } from './styles'

export interface ResponseNavBarProps {
  currentIndex: number
  total: number
  onPrev: () => void
  onNext: () => void
  /** Word used in aria-labels — e.g. "response", "interview". */
  itemNoun?: string
}

/**
 * Floating pill, fixed to the viewport bottom, that flips through a list of
 * items with prev/next buttons and a "N of M" indicator. The actual state
 * comes from `useResponseNavigation`.
 */
export function ResponseNavBar({
  currentIndex,
  total,
  onPrev,
  onNext,
  itemNoun = 'response',
}: ResponseNavBarProps) {
  return (
    <NavBar role="navigation" aria-label={`${itemNoun} navigation`}>
      <NavButton
        type="button"
        onClick={onPrev}
        disabled={currentIndex === 0}
        aria-label={`Previous ${itemNoun}`}
      >
        <ChevronLeft size={18} />
      </NavButton>
      <NavLabel>
        {currentIndex + 1} of {total}
      </NavLabel>
      <NavButton
        type="button"
        onClick={onNext}
        disabled={currentIndex >= total - 1}
        aria-label={`Next ${itemNoun}`}
      >
        <ChevronRight size={18} />
      </NavButton>
    </NavBar>
  )
}
